module.exports = __webpack_public_path__ + "img/01.7c30781f.jpg";